import { PageLink } from 'models/PageLink';
import { ShopSearchRawQueryParams } from 'models/ShopSearchRawQueryParams';
import { GetServerSidePropsContext } from 'next';
import { normalizeShopSearchRawQuery } from './normalizeShopSearchRawQuery';
import { Environment } from 'models/Environment';
import { getCategoryPageLinksFromApi } from './getCategoryPageLinksFromApi';
import { getAlternatePageLinksFromConfig } from './getAlternatePageLinksFromConfig';
import { allQueryParamsFalsy } from './allQueryParamsFalsy';
import { getKeywordPageLinksFromApi } from './getKeywordPageLinksFromApi';

export async function getPageLinks(
  context: GetServerSidePropsContext,
  environment: Environment
): Promise<PageLink[]> {
  if (typeof window !== 'undefined') {
    return [];
  }

  const query = normalizeShopSearchRawQuery(
    context.query as ShopSearchRawQueryParams
  );

  if (!allQueryParamsFalsy(query)) {
    return [];
  }

  const category = query.category;
  const keyword = query.keyword;
  const account = query.account;

  if (account) {
    return getAlternatePageLinksFromConfig(environment, { account });
  }

  if (keyword && category) {
    return await getKeywordPageLinksFromApi({ environment, category, keyword });
  }

  if (category) {
    return await getCategoryPageLinksFromApi({ environment, category });
  }

  return getAlternatePageLinksFromConfig(environment, {});
}
